import { ListBox, Table } from '@flos/react-ui';
import { type RowInformation } from '../../../config/flavourConfig';
import { getCoverableDetailsLimitedSumsConfig } from '../utils/CoverableDetailsLimitedSumsUtil';
import { type CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import TableRowWithBullets from '../../../shared_components/TableRowWithBullets/TableRowWithBullets';
import useWindowSize from '../../../hooks/useWindowSize';

const CoverableDetailsLimitedSums = ({
    coverable
}: {
    coverable: CoverableDTO;
}): React.JSX.Element => {
    const { isMobileDevice } = useWindowSize();
    const componentProperties = getCoverableDetailsLimitedSumsConfig(coverable);
    const coverableProperties = componentProperties?.rowsInformation.filter(
        (tableInfo) => !tableInfo.hidden
    );
    if (!coverable || !coverableProperties || coverableProperties.length === 0) {
        return <></>;
    }
    return (
        <div className="u-spacing-inset-m--stretch-max">
            <ListBox
                title={componentProperties?.title ?? ''}
                isOpen={!isMobileDevice}
                subtitle={componentProperties?.subtitle}
            >
                <Table mobileDirection="vertical" className="u-spacing-stack-sm" wrapped={true}>
                    <Table.Body>
                        {coverableProperties.map((rowInfo: RowInformation) => {
                            return <TableRowWithBullets key={rowInfo.name} rowInfo={rowInfo} />;
                        })}
                    </Table.Body>
                </Table>
            </ListBox>
        </div>
    );
};

export default CoverableDetailsLimitedSums;
